$(document).ready(function(){

    // Counters (Home Page Effect)
    // $('.counter-count').each(function () {
    //     $(this).prop('Counter',0).animate({
    //         Counter: $(this).text()
    //     }, {
    //         duration: 5000,
    //         easing: 'swing',
    //         step: function (now) {
    //             $(this).text(Math.ceil(now));
    //         }
    //     });
    // });

    // Set Copyright year
    document.getElementById("year").innerHTML = new Date().getFullYear();

    $(window).scroll(function() {
        var nav = $('#navbarMain');
        var top = 150;
        if ($(window).scrollTop() >= top) {

            nav.addClass('fixed');

        } else {
            nav.removeClass('fixed');
        }
    });

    // Like Btn Effect on Click (Models Listing, Model Profile)
    $('button.like-btn').on('click', function(){
        $(this).find('.icon').toggleClass('icon-heart');
        $(this).find('.icon').toggleClass('icon-heart-full');
    });

   
    // Mobile menu open on Click
    $('#mobOpenMenu').on('click', function() {

        $(this).find('.icon').toggleClass('icon-hamburger-menu');
        $(this).find('.icon').toggleClass('icon-cross');

        $('#mobOpenUser').find('.icon').removeClass('icon-cross');
        $('#mobOpenUser').find('.icon').addClass('icon-user-round');

        $('#respUser').removeClass('open');
        $('#respSearch').removeClass('open');
        $('#respMenu').toggleClass('open');
    });
    
    $('#mobOpenUser').on('click', function() {

        $(this).find('.icon').toggleClass('icon-user-round');
        $(this).find('.icon').toggleClass('icon-cross');

        $('#mobOpenMenu').find('.icon').removeClass('icon-cross');
        $('#mobOpenMenu').find('.icon').addClass('icon-hamburger-menu');

        $('#respMenu').removeClass('open');
        $('#respSearch').removeClass('open');
        $('.hamburger').removeClass('is-active');
        $('#respUser').toggleClass('open');
    });
 
    $('#mobOpenSearch').on('click', function() {
        $('#respUser').removeClass('open');
        $('#respMenu').removeClass('open');
        $('.hamburger').removeClass('is-active');
        $('#respSearch').toggleClass('open');
    }); 

    $('.mob-clouse').on('click', function() {
        $('.mnav-wrap').removeClass('open');
        $('.hamburger').removeClass('is-active');

        $('#mobOpenUser').find('.icon').removeClass('icon-cross');
        $('#mobOpenUser').find('.icon').addClass('icon-user-round');
        $('#mobOpenMenu').find('.icon').removeClass('icon-cross');
        $('#mobOpenMenu').find('.icon').addClass('icon-hamburger-menu');
    });

    // Toggle Button (Models Listing Page, About Section)
    function showMoreBtn(x) {
        $(x).find('#show-more').toggleClass('d-none');
        $(x).find('#show-more').toggleClass('d-flex');
        $(x).find('#show-less').toggleClass('d-none');
        $(x).find('#show-less').toggleClass('d-flex');
    }

    $('#about-toggle').on('click', function(){
        showMoreBtn(this);
    });

    $('#model-toggle').on('click', function(){
        showMoreBtn(this);
        $("#model-desc").toggleClass("desc-collapsed", 1000);
    });

    var count = $("#model-desc").text().length;
    if(count > 400) {
        $("#model-toggle").removeClass("d-none");
        $("#model-desc").addClass("desc-collapsed");
        $("#model-desc").addClass("has-button");
    }

    // // Scroll to Element
    function scrollToElement(element) {
        $('html, body').animate({
            scrollTop: $(element).offset().top-80
        }, 1000);
    }

    $("#goto-info").click(function (){
        scrollToElement("#model-info");
    });

    $("#goto-terms").click(function(){
        scrollToElement("#contest-terms");
    });

    $("#go-to-review").click(function(){
        scrollToElement("#your-review");
    });

    $('#goto-stats-1').click(function(){
        scrollToElement("#reviews-stats");
    });

    $('#goto-stats-2').click(function(){
        scrollToElement("#reviews-stats");
    });

    // Responsive Filters Show & Hide
    function closeFilters() {
        $("#filters").toggleClass("show");
        $("body").toggleClass("overflow-hidden");
    }

    $("#filter-trigger").click(function(){
        closeFilters();
    });

    $("#filter-confirm").click(function(){
        closeFilters();
    });

    $("#close-filters").click(function(){
        closeFilters();
    });

    

    // Custom File Input
    $(".custom-file-input").on("change", function() {
      var fileName = $(this).val().split("\\").pop();
      $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
    });

    // Show/Hide Rank
    $("#rank-info").click(function(){
        $("#rank-show").toggleClass("hide");
        $("#rank-show").toggleClass("show");
    });

        // Show/Hide Rank
    $("#shere-info").click(function(){
        $("#shere-show").toggleClass("hide");
        $("#shere-show").toggleClass("show");
    });

    // Contest Page: Vote Btn
    $(".vote-btn").click(function(){
        $(this).toggleClass("vote");
        $(this).toggleClass("voted");
    });

    loopcounter('counter-class');

    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })

});